import * as React from "react";
import { IStateApp } from "../Reducers";
import { connect } from "react-redux";
import { createActionFetchFaenas } from "../Actions/Session/Actions";
import FilterReport from "../Components/FilterReport";
import "./ReportSummary.scss";
import { Producer, Branch, Summary } from "../Models/Report";
import {
	createActionSetProducer,
	EReport,
	createActionClearData,
	createActionSetBranch,
	createActionRequestAnounced,
} from "../Actions/Report/Actions";
import { IReportState } from "../Reducers/Report";
import CardSummary from "../Components/CardSummary";
import { getColorQuality } from "../Models/Colors";
import { IAccount } from "../Models/Account";
import Loading from "./Loading";
import SummaryBranch from "./SummaryBranch";
import { capitalize } from "../Utils/StrUtil";
import Box from "../Components/Box";
import Emply from "antd/lib/empty";
import { ScreenSelection } from "./ScreenSelection";

export interface IHeaderSummaryProps {
	name: string;
	message: string;
}

const HeaderSummary = (props: IHeaderSummaryProps) => (
	<div>
		<h1>
			{props.message} {capitalize(props.name)}
		</h1>
		<p>Estatus del cobre en Puerto Angamos</p>
	</div>
);

export interface IReportSummaryProps extends IReportState {
	onFaenas: (id: number) => void;
	onClear: () => void;
	producers: Producer[];
	account: IAccount;
	setProducer: (id: number, idProducer: string, report: EReport) => void;
	setBranch: (id: number, idProducer: string, idBranch: number) => void;
	requestAction: () => void;
	report: EReport;
	section: string;
	prefix?: string;
	suffix?: string;
}

class ReportSummary extends React.Component<IReportSummaryProps> {
	state = {
		branch: undefined,
		producer: "",
	};
	componentWillMount() {
		this.props.onClear();
		if (this.props.account) {
			this.props.onFaenas(this.props.account.id);
		}
	}

	getNameProducer(idProducer: string) {
		const current = this.props.producers.find((p) => p.id === idProducer);
		if (current) {
			return current.name;
		}
		return "";
	}

	onChangeProducer(value: string | number) {
		this.setState({ ...this.state, producer: value, branch: undefined });
		this.props.setProducer(
			this.props.account.id,
			value as string,
			this.props.report
		);
	}

	onChangeBranch(value: string | number) {
		let producer: string = this.state.producer
			? (this.state.producer as string)
			: "";
		if (producer === "" && this.props.producers.length > 0) {
			producer = this.props.producers[0].id;
		}
		this.props.setBranch(this.props.account.id, producer, value as number);
		this.setState({ ...this.state, branch: value, producer });

		this.props.requestAction();
		setTimeout(() => {
			this.props.requestAction();
		}, 500);
	}

	render() {
		if (
			this.props.producers.length === 1 &&
			!this.props.announced &&
			!this.props.isRequestAnnounced &&
			this.state.producer === ""
		) {
			this.props.setProducer(
				this.props.account.id,
				this.props.producers[0].id,
				this.props.report
			);
			this.setState({ ...this.state, producer: this.props.producers[0].id });
		}
		const notSelectedProducer =
			!this.state.producer || this.state.producer === "";
		const showBox =
			this.props.announced !== undefined &&
			this.props.announced.length > 0 &&
			!this.props.isRequestAnnounced &&
			!notSelectedProducer;
		const announced =
			this.props.announced && this.props.announced.length > 0
				? this.props.announced.find((a) => a.idProducer === this.state.producer)
				: undefined;
		return (
			<div className="ReportSummary">
				<h1>
					{this.props.prefix || "Detalle cobre estado"} {this.props.section}{" "}
					{this.props.suffix} {this.getNameProducer(this.state.producer)}
				</h1>
				<FilterReport
					ignoreFilter={true}
					selected={announced}
					onChangeBranch={this.onChangeBranch.bind(this)}
					onChangeProducer={this.onChangeProducer.bind(this)}
					producers={this.props.producers}
				/>
				{!showBox && !this.props.isRequestAnnounced && <ScreenSelection />}
				{this.props.isRequestAnnounced && <Loading />}
				{showBox && !this.state.branch && this.renderSummary()}
				{showBox && this.state.branch && this.renderBranch()}
			</div>
		);
	}

	private renderSummary() {
		const EmplyFn = () => (
			<Box loading={false}>
				<div className="CardSummary">
					<Emply description="No tenemos datos para mostrar" />
				</div>
			</Box>
		);
		if (!this.props.announced || this.props.announced.length === 0) {
			debugger;
			return <EmplyFn />;
		}
		const announced = this.props.announced.find(
			(a) => a.idProducer === this.state.producer
		);
		if (announced) {
			return (
				<div className="ReportSummary-Chart">
					<CardSummary
						key="card-summary-branch"
						loading={this.props.isRequestAnnounced}
						titleItem={`${this.props.section} por Faena`}
						titleGraph={`${this.props.section} por faena`}
						data={announced.branchs.map((b: Branch, index: number) => ({
							name: b.name,
							total: b.total,
							color: getColorQuality(index),
						}))}
					/>
					<CardSummary
						key="card-summary-quality"
						loading={this.props.isRequestShipment}
						titleItem="Calidad del Cobre"
						titleGraph="Calidad del cobre total"
						data={announced.quality.map((s: Summary, index: number) => ({
							...s,
							color: getColorQuality(index),
						}))}
					/>
				</div>
			);
		}
		return <EmplyFn />;
	}

	private renderBranch() {
		const announced =
			this.props.announced && this.props.announced.length > 0
				? this.props.announced.find((a) => a.idProducer === this.state.producer)
				: undefined;
		return (
			<SummaryBranch
				report={this.props.section}
				reportType={this.props.report}
				loading={this.props.isRequestShipment}
				selected={announced!}
				shipmentData={this.props.shipmentSummary!}
				selectedBranch={this.state.branch!}
			/>
		);
	}
}

const mapProps = (state: IStateApp) => ({
	...state.report,
	account: state.session.account,
});

const mapAction = (dispatch: any) => ({
	onFaenas: (id: number) => dispatch(createActionFetchFaenas(id, false)),
	onClear: () => dispatch(createActionClearData(EReport.Announced)),
	setProducer: (id: number, idProducer: string, report: EReport) =>
		dispatch(createActionSetProducer(id, idProducer, report)),
	setBranch: (id: number, idProducer: string, idBranch: number) =>
		dispatch(createActionSetBranch(id, idProducer, idBranch)),
	requestAction: () => dispatch(createActionRequestAnounced()),
});

export default connect<IReportSummaryProps>(
	mapProps as any,
	mapAction
)(ReportSummary) as any;
